<template>
    <!-- 奖牌榜 -->
    <div>
        <div class="i-cont">数据统计截止至{{nowDate.replaceAll('-','.')}}</div>
        <div class="medal">
            <div class="title row">
                <div class="col1  t-col">排名</div>
                <div class="col2  t-col">代表队</div>
                <div class="col3  t-col">
                    积分
                </div>
            </div>
            <template v-if="medalList.length>0">
                <div class="row" @click="rowClick(item)" v-for="(item, index) in medalList" :key="index">
                    <div class="col1">{{ (rankParams.pageNum-1)*rankParams.pageSize + 1+index }}</div>
                    <div class="col2">{{ item.agencyName }}</div>
                    <div class="col3">{{ item.score }}</div>
                </div>
            </template>
            <template v-else>
                <a-empty class="empty">
                    <span slot="description">暂无数据</span>
                </a-empty>
            </template>
        </div>
    </div>

</template>

<script>
import {filterTime} from '@comm/utils/handleDateTime'

export default {
  props: {
    medalList: {
      type: Array,
      default: ()=>{
        return []
      }
    },
    rankParams: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    total: {
      type: Number,
      default: 0
    },
    isHome: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      nowDate:filterTime(),
    }
  },
  methods: {
    rowClick (item) {
      this.$emit('rowClick', item)
    },
    handlePage (page, pageSize){
      this.$emit('handlePage', page, pageSize)
    }
  }
}
</script>

<style lang="scss" scoped>
.i-cont{
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 10px;
}
.medal{
    border: 4px solid #124584;
    box-sizing: border-box;
    border-radius: 10px;
    width: 1200px;
    margin: 0 auto;
    .row{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        height: 60px;
        line-height: 60px;
        box-sizing: border-box;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 1px solid #ACD0FD;
        cursor: pointer;
        .col1{
            width: 100px;
            height: 100%;
             box-sizing: border-box;
        }
        .col2{
            width: 1000px;
            height: 100%;
            text-align: left;
            padding-left: 10px;
            box-sizing: border-box;
            border-left: 1px solid #ACD0FD;
            border-right: 1px solid #ACD0FD;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .col3{
            width: 100px;
             height: 100%;
              box-sizing: border-box;
        }
        .col4{
            width: 15%;
             height: 100%;
              box-sizing: border-box;
                border-left: 1px solid #ACD0FD;
             border-right: 1px solid #ACD0FD;
        }
        .col5{
            width: 15%;
             height: 100%;
              box-sizing: border-box;
             border-right: 1px solid #ACD0FD;
        }
        .col6{
            width: 15%;
            height: 100%;
            box-sizing: border-box;
        }
        .t-col{
            border: none;
            img{
                width: 60px;
                height: 60px;
            }
        }
    }
    .title{
        height: 76px;
        line-height: 80px;
        background-color: #124584;
        color: #ffffff;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        .col2{
            text-align: center;
        }
    }
    .pagination{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin:20px 0 ;
    }
    .empty{
        min-height: 400px;
        padding-top: 100px;
    }
}
</style>



// WEBPACK FOOTER //
// src/district/components/home/RankingScore.vue